
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.53 2.082H2.826a.741.741 0 00-.741.741v3.706c0 .409.332.74.74.74h3.707a.74.74 0 00.74-.74V2.823a.741.741 0 00-.74-.741zm8.646 0h-3.705a.741.741 0 00-.741.741v3.706c0 .409.332.74.74.74h3.706a.741.741 0 00.741-.74V2.823a.74.74 0 00-.74-.741zm-8.645 8.646H2.825a.74.74 0 00-.741.74v3.706c0 .41.332.741.74.741h3.707a.74.74 0 00.74-.74v-3.706a.74.74 0 00-.74-.741zm8.645 0h-3.705a.741.741 0 00-.741.74v3.706c0 .41.332.741.74.741h3.706a.74.74 0 00.741-.74v-3.706a.74.74 0 00-.74-.741z","stroke":"currentColor","stroke-width":"1.88","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    